import { msg } from "@lit/localize";

export const CONTENT = () => [
  {
    name: msg("Java Collections"),
    uuid: "8d1a3a42-1f57-4d14-90ee-4f4838aed776",
    path: "java/collections/levels.ts",
    lessons: [
      {
        name: msg("Hello world!"),
        uuid: "742ad6ad-22bf-4b3c-87d3-5d3abfc68fcc",
        path: "java/collections/lesson-1.ts"
      }
    ]
  },
  {
    name: msg("Java Multithreading"),
    uuid: "8a84f6a6-94f0-4e8f-a815-061f3f0c5d42",
    path: "java/concurrency/levels.ts",
    lessons: [
      {
        name: msg("Thread Class"),
        uuid: "34aabf75-71be-4a6d-b3f9-e6be5168eb7c",
        path: "java/concurrency/lesson-1.ts"
      },
      {
        name: msg("Synchronization"),
        uuid: "cfb5099d-d09e-4218-825b-60848529e8c0",
        path: "java/concurrency/lesson-2.ts"
      },
      {
        name: msg("ReentrantLock"),
        uuid: "fb055dc4-ba29-47f5-9613-b3146a48191d",
        path: "java/concurrency/lesson-3.ts"
      },
      {
        name: msg("Read/Write Locks"),
        uuid: "c405b593-dbe2-4597-a407-8ac4785b7a32",
        path: "java/concurrency/lesson-4.ts"
      },
      {
        name: msg("Executors 1"),
        uuid: "896a3f82-1fa1-4ef6-bd50-222784f2cc75",
        path: "java/concurrency/lesson-5.ts"
      },
      {
        name: msg("Executors 2"),
        uuid: "dfbcaca8-032f-42a1-90e1-61e3b168312c",
        path: "java/concurrency/lesson-6.ts"
      },
      {
        name: msg("Executors 3"),
        uuid: "7eea2a4f-ccdf-4a85-afe3-7003ad73a056",
        path: "java/concurrency/lesson-7.ts"
      },
      {
        name: msg("Atomics"),
        uuid: "e5311302-270b-49d8-a891-e5f20d2e511d",
        path: "java/concurrency/lesson-8.ts"
      },
      {
        name: msg("Thread-safe collections"),
        uuid: "1b809d27-5699-4ca8-809c-8a8ab62312a0",
        path: "java/concurrency/lesson-9.ts"
      }
    ]
  },
  {
    name: msg("Java 101"),
    uuid: "5c56c51f-c2fb-4126-9a87-e6b4b42e00d7",
    path: "java/core/levels.ts",
    lessons: [
      {
        name: msg("Hello world!"),
        uuid: "bd91e3a5-b4ef-490f-bb78-c50a80e36a5c",
        path: "java/core/lesson-1.ts"
      }
    ]
  },
  {
    name: msg("JUnit Testing"),
    uuid: "d7e0dcf0-cb71-4686-823a-0ca301c2675f",
    path: "java/junit/levels.ts",
    lessons: [
      {
        name: msg("@Test"),
        uuid: "2ca0fc30-15e1-4929-98d0-b0268da2018d",
        path: "java/junit/lesson-1.ts"
      },
      {
        name: msg("Assertions 1"),
        uuid: "db67d6f4-2d2b-4287-8e7f-12ecacbc8157",
        path: "java/junit/lesson-2.ts"
      },
      {
        name: msg("Assertions 2"),
        uuid: "10506d3e-29af-4572-aff8-839baa76797c",
        path: "java/junit/lesson-3.ts"
      },
      {
        name: msg("Mockito Mocks"),
        uuid: "da05f7ae-ff7e-4661-8c89-4a34f1cffb47",
        path: "java/junit/lesson-4.ts"
      },
      {
        name: msg("Mockito Spies"),
        uuid: "5f635d03-bef0-4546-9747-55caf68ccb74",
        path: "java/junit/lesson-5.ts"
      },
      {
        name: msg("Annotations"),
        uuid: "8abf203b-e0ac-40bd-87a4-44bea8ba120c",
        path: "java/junit/lesson-6.ts"
      },
      {
        name: msg("Parameterized Tests"),
        uuid: "9915f357-886e-4135-a767-17b520df0339",
        path: "java/junit/lesson-7.ts"
      },
      {
        name: msg("Best Practices"),
        uuid: "f510853c-b986-4caf-bd4c-028a6be44e7d",
        path: "java/junit/lesson-8.ts"
      }
    ]
  },
  {
    name: msg("Java Stream API"),
    uuid: "fb9c0e53-0fde-4f49-a845-6b42d0027d09",
    path: "java/stream-api/levels.ts",
    lessons: [
      {
        name: msg("Filtering"),
        uuid: "02bd28cb-fce5-4b72-9b11-8aae97d00111",
        path: "java/stream-api/lesson-1.ts"
      },
      {
        name: msg("Mapping"),
        uuid: "fcf7e1b0-e505-4de9-a374-8341b808dd9a",
        path: "java/stream-api/lesson-2.ts"
      },
      {
        name: msg("Collecting"),
        uuid: "548fc96b-18a1-46dd-ba9c-ea8ab0a191e1",
        path: "java/stream-api/lesson-3.ts"
      },
      {
        name: msg("To Map"),
        uuid: "d00c7e20-1738-4884-abc8-1f3c12040ad8",
        path: "java/stream-api/lesson-4.ts"
      },
      {
        name: msg("Stateful operations 1"),
        uuid: "7a1bd9df-88d1-4ecf-8f74-219b91fc1dd1",
        path: "java/stream-api/lesson-5.ts"
      },
      {
        name: msg("Stateful operations 2"),
        uuid: "6113666c-5045-413f-9a8f-9958780053d5",
        path: "java/stream-api/lesson-6.ts"
      },
      {
        name: msg("Terminals 1"),
        uuid: "bdc999e1-2816-4e25-8b31-f68024925b05",
        path: "java/stream-api/lesson-7.ts"
      },
      {
        name: msg("Terminals 2"),
        uuid: "488577f8-676f-4884-82c7-8dea5a95a4b7",
        path: "java/stream-api/lesson-8.ts"
      },
      {
        name: msg("Creating Stream"),
        uuid: "9f84c668-7def-4897-b313-1eded48b9f1f",
        path: "java/stream-api/lesson-9.ts"
      }
    ]
  },
  {
    name: msg("Shell 101"),
    uuid: "dd2f9319-bce9-4e43-8b45-12685ce6c6e2",
    path: "shell/shell/levels.ts",
    lessons: [
      {
        name: msg("Learning to Read"),
        uuid: "61703dec-4a0f-450f-b280-17fbda329fbd",
        path: "shell/shell/lesson-1.ts"
      },
      {
        name: msg("Pipes"),
        uuid: "edfc137d-b225-483e-9cd4-e1dd82c3909e",
        path: "shell/shell/lesson-10.ts"
      },
      {
        name: msg("Searching for it"),
        uuid: "edfc137d-b225-433e-9cd4-e1dd82c3149e",
        path: "shell/shell/lesson-11.ts"
      },
      {
        name: msg("Environment variables"),
        uuid: "edfc137d-b225-483e-9cd4-e1dd82c3949e",
        path: "shell/shell/lesson-12.ts"
      },
      {
        name: msg("History"),
        uuid: "491902cb-a91e-4378-894c-087677c25a92",
        path: "shell/shell/lesson-13.ts"
      },
      {
        name: msg("Learning to Write"),
        uuid: "716cf90a-b5e5-4ceb-ae74-1f77e42daf55",
        path: "shell/shell/lesson-2.ts"
      },
      {
        name: msg("Getting Organised"),
        uuid: "d5727ff0-1a9a-4d87-a480-8bd388285710",
        path: "shell/shell/lesson-3.ts"
      },
      {
        name: msg("Getting Rid of Things"),
        uuid: "edfc137d-b265-483e-9cd4-e1dd82c3908e",
        path: "shell/shell/lesson-4.ts"
      },
      {
        name: msg("Relative or Absolute"),
        uuid: "ea29737d-d6a5-4bf7-a536-0f40abee9f99",
        path: "shell/shell/lesson-5.ts"
      },
      {
        name: msg("Copy That"),
        uuid: "edfc137d-b265-483e-9cd4-e1dd82c3909e",
        path: "shell/shell/lesson-6.ts"
      },
      {
        name: msg("The Moves"),
        uuid: "edfc137d-b264-483e-9cd4-e1dd82c3909e",
        path: "shell/shell/lesson-7.ts"
      },
      {
        name: msg("Sorting it out"),
        uuid: "86350254-7bbd-497b-a643-874f38d11ff0",
        path: "shell/shell/lesson-8.ts"
      },
      {
        name: msg("Heads or tails?"),
        uuid: "59359e58-67d1-4dc1-a745-d8fee727e650",
        path: "shell/shell/lesson-9.ts"
      }
    ]
  },
  {
    name: msg("SQL Basics"),
    uuid: "6a4a747b-d7d9-4d22-a17c-8ebe974a78e8",
    path: "sql/basics/levels.ts",
    lessons: [
      {
        name: msg("Introduction"),
        uuid: "7adcad9b-ed5f-4065-b6da-5fe332c3ee0a",
        path: "sql/basics/lesson-1.ts"
      },
      {
        name: msg("Where are my kittens?"),
        uuid: "d503a50b-3620-4801-9a14-5d4c92c181d8",
        path: "sql/basics/lesson-2.ts"
      },
      {
        name: msg("The Null"),
        uuid: "81f27b55-3776-42b6-9db2-50ffbc730e1f",
        path: "sql/basics/lesson-3.ts"
      },
      {
        name: msg("What are cats like?"),
        uuid: "f8aef0ae-1875-4265-95db-16f141ae7f78",
        path: "sql/basics/lesson-4.ts"
      },
      {
        name: msg("Limit and order"),
        uuid: "68a0ba45-05ff-4524-b8f3-6891306ab446",
        path: "sql/basics/lesson-5.ts"
      },
      {
        name: msg("But First, Null"),
        uuid: "5d7e6cf3-15b2-4611-a428-a3b27a158d26",
        path: "sql/basics/lesson-6.ts"
      }
    ]
  }
];